import * as React from "react";

interface Props {
  viewBox?: string;
  color: string;
  size: string;
}

export const ProductRegua = (props: Props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox={props?.viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.667 16.333h1.666v-4.166h-7.5v-7.5H4.667v1.666h1.666V8H4.667v1.667h2.5v1.666h-2.5V13h1.666v1.667H4.667v1.666h1.666v-1.666H8v1.666h1.667v-2.5h1.666v2.5H13v-1.666h1.667v1.666ZM10.5 10.5h6.667a.833.833 0 0 1 .833.833v5.834a.833.833 0 0 1-.833.833H3.833A.833.833 0 0 1 3 17.167V3.833A.833.833 0 0 1 3.833 3h5.834a.833.833 0 0 1 .833.833V10.5Z"
      fill={props.color}
    />
  </svg>
);
